module.exports = __webpack_public_path__ + "img/related-image-02.1c017da9.jpg";